import { useState } from "react";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { queryClient } from "../../../../../../../utils/queryClient";
import { useMutation, useQuery } from "react-query";
//primereact
import { Skeleton } from "primereact/skeleton";
import { SplitButton } from "primereact/splitbutton";
import { confirmDialog } from "primereact/confirmdialog";
//components
import CardDocument from "../../../../../../../components/cards/CardDocument";
//services
import { getUsers } from "../../../../../../../services/GeneralRegistration/getUsers";
import { getConfigSign } from "../../../../../../../services/Enterprise/ClickSign/getConfigSign";
import { getDocumentsSales } from "../../../../../../../services/Contracts/getDocumentsSales";
import { getConfigContract } from "../../../../../../../services/Enterprise/ClickSign/getConfigContract";
import { deleteDocumentsContracts } from "../../../../../../../services/Contracts/deleteDocumentsContracts";
//modal
import { ModalDocuments } from "./ModalDocuments";
import { ModalSendSign } from "./ModalSendSign";
import { useAppContext } from "../../../../../../../context/AppContext";

const Documents = ({ setActiveIndex, id, cliId, enterpriseId }) => {
  const [fileVisibleSale, setFileVisibleSale] = useState(false);
  const [fileVisibleSign, setFileVisibleSign] = useState(false);
  const [defaultValues, setDefaultValues] = useState({});
  const [newSigner, setNewSigner] = useState([{}]);

  const { permissions } = useAppContext();

  const {
    data: signers,
    refetch: refetchSigners,
    isLoading: isLoadingSigners,
  } = useQuery({
    queryKey: [`signers${id}`],
    queryFn: () => getUsers(),
    enabled: !!permissions?.includes("10")
  });
  const {
    data: registeredSigners,
    refetch: refetchRegisterSigners,
    isLoading: isLoadingRegisterSigners,
  } = useQuery({
    queryKey: [`registeredSigners${id}`],
    queryFn: () => getConfigContract(id),
    enabled: !!permissions?.includes("78")
  });

  const {
    data: config_sign,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: [`config_sign${enterpriseId}`],
    queryFn: () => getConfigSign(enterpriseId),
    enabled: !!permissions?.includes("78")
  });

  const transformedDataSigners = registeredSigners?.map((item) => ({
    id: item.id,
    name: item.user.name,
    cpf: item.user.doc,
    email: item.user.email,
    userId: item.user.id,
    signer_desc: item.label_type_signer,
  }));

  const { data: files, isLoading: isLoadingFiles } = useQuery({
    queryKey: [`files${id}`],
    queryFn: () => getDocumentsSales(id),
    enabled: !!permissions?.includes("37")
  });

  const { mutateAsync: deleteDocumentsFn } = useMutation({
    mutationFn: deleteDocumentsContracts,
    onSuccess(_, variables) {
      queryClient.setQueryData([`files${id}`], (data) => {
        const updatedClientFiles = data.anexo_venda_client?.filter(
          (item) => item.id !== variables
        );
        const updatedSaleFiles = data.anexo_venda_sale?.filter(
          (item) => item.id !== variables
        );
        const updatedContractFiles = data.anexo_venda_contract?.filter(
          (item) => item.id !== variables
        );
        return {
          anexo_venda_client: updatedClientFiles,
          anexo_venda_sale: updatedSaleFiles,
          anexo_venda_contract: updatedContractFiles,
        };
      });
    },
  });

  const spreadsheet = [
    {
      label: "Venda",
      icon: "fa fa-hand-holding-dollar",
      command: () => {
        setDefaultValues({
          optionsDocument: "1",
        });
        setFileVisibleSale(true);
      },
    },
    {
      label: "Cliente",
      icon: "fa fa-user",
      command: () => {
        setDefaultValues({
          optionsDocument: "2",
        });
        setFileVisibleSale(true);
      },
    },
  ];

  function formatDateCard(dateString) {
    const parsedDate = new Date(dateString);
    const formattedDate = format(parsedDate, "MMM dd, yyyy");
    return formattedDate;
  }

  const clickButton = () => {
    setDefaultValues({});
    setFileVisibleSale(true);
  };

  const acceptDelete = async (idDoc) => {
    const notification = toast.loading("Por favor aguarde...");
    try {
      await deleteDocumentsFn(idDoc);
      toast.update(notification, {
        render: "Documento Deletado com Sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (err) {
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
      });
    }
  };

  const deleteDoc = async (idDoc) => {
    confirmDialog({
      message: "Deseja Deletar o Documento?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => acceptDelete(idDoc),
    });
  };
  const getFileExtension = (url) => {
    const path = url?.split("?")[0]; // Ignora os parâmetros da query string
    return path?.split(".").pop(); // Obtém a extensão do arquivo
  };

  const getFileType = (extension) => {
    const extensionMap = {
      pdf: "pdf",
      docx: "docx",
      xlsx: "xlsx",
      png: "png",
      jpeg: "jpeg",
      jpg: "jpg",
    };

    return extensionMap[extension?.toLowerCase()] || "unknown";
  };

  const clickSign = (file, name, id) => {
    const pathName = name?.split(".")[0]; // Ignora os parâmetros da query string
    const extension = getFileExtension(file);
    const typeFile = getFileType(extension);
    setDefaultValues({
      file_name: pathName,
      idFile: id,
    });
    setFileVisibleSign(true);
  };
  return (
    <>
      <div className="row">
        <div className="card-border me-2 my-2">
          <div className="title-container">
            <p>
              {" "}
              <i className="fa-solid fa-file me-2"></i>Documentos
            </p>
          </div>
          <div className="row my-2 me-2 p-4">
            <div className="row justify-content-between">
              <div className="col-xl-6 my-auto">
                <h4 className="text-success">
                  <i className="fa-solid fa-hand-holding-dollar mx-2"></i>
                  Documentos Cadastrados da Venda
                </h4>
              </div>
              {permissions && permissions.includes("75") && ( //Adicionar Anexos 
                <div className="col-xl-6 text-end">
                  <SplitButton
                    label="Anexar Arquivo"
                    icon="fa fa-plus"
                    model={spreadsheet}
                    onClick={clickButton}
                    rounded
                    className="pb-2"
                  />
                </div>
              )}
            </div>
            <hr />
            {isLoadingFiles && (
              <Skeleton width="100%" height="240px"></Skeleton>
            )}
            {files &&
              files.length !== 0 &&
              files.anexo_venda_sale?.map((d, index) => {
                return (
                  <CardDocument
                    key={index}
                    idDoc={d.id}
                    deleteFunction={deleteDoc}
                    doNotDelete={permissions && !permissions.includes("76")}//Deletar Anexo 
                    date={formatDateCard(d.created_at)}
                    fileName={d.name}
                    hasViewFile={true}
                    file={d.file}
                    description={d.desc}
                    actions={true}
                    hasLink={true}
                    size={`Tam: ${d.size}`}
                    preview={
                      (d.extension === "png" || d.extension === "jpeg") &&
                      d.file
                    }
                    type={d.extension}
                  />
                );
              })}

            <h4 className="text-success mt-4">
              <i className="fa-solid fa-user mx-2"></i>Documentos Cadastrados do
              Cliente
            </h4>
            <hr />
            {isLoadingFiles && (
              <Skeleton width="100%" height="240px"></Skeleton>
            )}

            {files &&
              files.length !== 0 &&
              files.anexo_client?.map((d, index) => {
                return (
                  <CardDocument
                    key={index}
                    idDoc={d.id}
                    deleteFunction={deleteDoc}
                    date={formatDateCard(d.created_at)}
                    doNotDelete={permissions && !permissions.includes("76")}//Deletar Anexo 
                    fileName={d.name}
                    file={d.file}
                    description={d.desc}
                    actions={true}
                    hasLink={true}
                    size={`Tam: ${d.size}`}
                    preview={
                      (d.extension === "png" || d.extension === "jpeg") &&
                      d.file
                    }
                    type={d.extension}
                  />
                );
              })}
            <h4 className="text-success mt-4">
              <i className="fa-solid fa-file mx-2"></i>Contratos Gerados
            </h4>
            <hr />
            {isLoadingFiles && (
              <Skeleton width="100%" height="240px"></Skeleton>
            )}

            {files &&
              files.length !== 0 &&
              files.anexo_venda_contract?.map((d, index) => {
                return (
                  <CardDocument
                    key={index}
                    idDoc={d.id}
                    deleteFunction={deleteDoc}
                    doNotDelete={permissions && !permissions.includes("76")}//Deletar Anexo 
                    date={formatDateCard(d.created_at)}
                    fileName={d.name}
                    file={d.file}
                    description={d.desc}
                    actions={true}
                    hasLink={true}
                    clickSign={clickSign}
                    hasViewFile={true}
                    size={`Tam: ${d.size}`}
                    preview={
                      (d.extension === "png" || d.extension === "jpeg") &&
                      d.file
                    }
                    type={d.extension}
                  />
                );
              })}
          </div>
        </div>
      </div>

      <ModalDocuments
        visible={fileVisibleSale}
        setVisible={setFileVisibleSale}
        defaultValues={defaultValues}
        idSale={id}
        idClient={cliId}
      />
      <ModalSendSign
        visible={fileVisibleSign}
        setVisible={setFileVisibleSign}
        defaultValues={defaultValues}
        idSale={id}
        isLoadingSigners={isLoadingSigners}
        isLoading={isLoading}
        idClient={cliId}
        signers={signers}
        config_sign={config_sign}
        newSigner={newSigner}
        setNewSigner={setNewSigner}
        transformedDataSigners={transformedDataSigners}
        refetchRegisterSigners={refetchRegisterSigners}
      />
    </>
  );
};

export default Documents;
